<template>
  <div class="common-problem-page">
    <div class="problem-card" v-loading="loading">
      <h1 class="problem-title">常见问题解答</h1>
      <div v-if="contentHtml" class="problem-content" v-html="contentHtml"></div>
      <div v-else class="problem-empty">暂无常见问题内容</div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  name: "CommonProblem",
  data() {
    return {
      loading: false,
      contentHtml: ""
    };
  },
  created() {
    this.loadProblemInfo();
  },
  methods: {
    escapeHtml(raw) {
      return String(raw)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    normalizeContent(text) {
      if (!text) {
        return "";
      }
      const str = String(text).trim();
      if (!str) {
        return "";
      }
      if (/<[a-z][\s\S]*>/i.test(str)) {
        return str;
      }
      return this.escapeHtml(str).replace(/\r?\n/g, "<br/>");
    },
    async loadProblemInfo() {
      this.loading = true;
      try {
        const res = await httpRequest("/app/setting/info", "get", null);
        if (res && res.code === 200 && res.data) {
          const data = res.data || {};
          const raw =
            data.troubleShooting ||
            data.trouble_shooting ||
            data.regarding ||
            data.durationDescription ||
            "";
          this.contentHtml = this.normalizeContent(raw);
          return;
        }
        this.contentHtml = "";
      } catch (error) {
        this.contentHtml = "";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.common-problem-page {
  width: 100%;
  padding: 30px 0 40px;
}

.problem-card {
  width: 1200px;
  min-height: 640px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  text-align: left;
  padding: 32px 48px 40px;
}

.problem-title {
  margin: 10px 0 24px;
  text-align: center;
  color: #1e293b;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
}

.problem-content {
  color: #334155;
  font-size: 15px;
  line-height: 1.8;
  word-break: break-word;
}

.problem-empty {
  text-align: center;
  margin-top: 120px;
  color: #9ca3af;
  font-size: 14px;
}
</style>
